import propTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import Paper from 'material-ui/Paper';
import IconButton from 'material-ui/IconButton';
import { List } from 'material-ui/List';
import KeyboardArrowDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import KeyboardArrowUp from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import Close from 'material-ui/svg-icons/navigation/close';
import * as Colors from 'material-ui/styles/colors';
import { Scrollbars } from 'shared/vendor/react-custom-scrollbars/src/index';
import { renderTrackVerticalDefault } from 'shared/vendor/react-custom-scrollbars/src/Scrollbars/defaultRenderElements';

function getContainerStyle({ open }, { headerHeight, containerHeight, containerWidth, fixedPosition, actionBarMargin }) {
  return {
    width: `${containerWidth}px`,
    height: `${containerHeight}px`,
    position: fixedPosition ? 'fixed' : 'absolute',
    right: 100,
    bottom: `${open ? actionBarMargin : headerHeight - containerHeight + actionBarMargin}px`,
    transition: 'all 0.5s',
    zIndex: 998,
  };
}

function headerStyle({ headerHeight }) {
  return {
    color: '#fff',
    background: Colors.grey800,
    width: '100%',
    height: `${headerHeight}px`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
  };
}

export default class MultiItemStatusBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (_.size(nextProps.children) > _.size(this.props.children)) {
      this.setState({ open: true });
    }
  }

  getHeader() {
    const { open } = this.state;
    const { headerLabel, showRemoveAllButton } = this.props;
    return (
      <div
        style={headerStyle(this.props)}
        onClick={this.toggleMultiItemStatusBar}
      >
        <div style={{ marginLeft: 20 }}>
          {headerLabel}
        </div>
        <div>
          <IconButton onClick={this.toggleMultiItemStatusBar}>
            { open ? <KeyboardArrowDown color={Colors.white} />
                   : <KeyboardArrowUp color={Colors.white} />}
          </IconButton>
          { showRemoveAllButton && <IconButton onClick={this.removeAll}>
            <Close color={Colors.white} />
          </IconButton>
          }
        </div>
      </div>
    );
  }

  removeAll = e => {
    e.stopPropagation();
    this.props.removeAll();
  };

  toggleMultiItemStatusBar = () => {
    this.setState({ open: !this.state.open });
  };

  renderTrackVertical({ style, ...props }) {
    const finalStyle = {
      ...style,
      right: 2,
      bottom: 2,
      top: 2,
      borderRadius: 3,
      zIndex: 9999,
    };
    return <div style={finalStyle} {...props} />;
  }

  render() {
    const { subHeader, containerStyle, listStyle, containerHeight, headerHeight,
            subHeaderHeight, children } = this.props;
    return (
      <Paper
        style={{...getContainerStyle(this.state, this.props), ...containerStyle}}
        zDepth={2}
      >
        {this.getHeader()}
        {subHeader ? subHeader() : ''}
        <div style={{ height: containerHeight - headerHeight - subHeaderHeight }}>
          <Scrollbars renderTrackVertical={this.renderTrackVertical}>
            <List style={listStyle}>
              {children}
            </List>
          </Scrollbars>
        </div>
      </Paper>
    );
  }
}

MultiItemStatusBar.propTypes = {
  containerStyle: propTypes.object,
  headerLabel: propTypes.string,
  listItems: propTypes.array,
};

MultiItemStatusBar.defaultProps = {
  containerHeight: 410,
  containerWidth: 450,
  headerHeight: 60,
  subHeaderHeight: 40,
  listStyle: {
    height: '100%',
    padding: 0,
  },
  fixedPosition: false,
  actionBarMargin: 0,
};